<template>
  <Card class="menu-card">
    <el-menu slot="title" :default-active="type" mode="horizontal" @select="setType">
      <el-menu-item index="中药处方划价单">处方划价单列表</el-menu-item>
      <!-- <el-menu-item index="隐秘处方划价单">隐秘处方划价单列表</el-menu-item>
      <el-menu-item index="理疗处方划价单" v-if="physioFlag">理疗处方划价单列表</el-menu-item> -->
    </el-menu>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getOrdersList)" class="fr">刷新</el-button>
    <div slot="content" class="wrap">
      <el-form inline :model="searchForm" class="search">
        <el-form-item label="患者姓名">
          <el-input v-model="searchForm.patientName" placeholder="请输入患者姓名" />
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="searchForm.phone" placeholder="请输入患者手机号码" />
        </el-form-item>
        <el-form-item label="医生姓名">
          <el-select allow-create clearable v-model="searchForm.doctorName" placeholder="请选择医生" filterable
            default-first-option>
            <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.label">
              <span class="fl">{{ item.label }}</span>
              <span class="select-flex">{{ item.phone }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
           <el-select allow-create clearable v-model="searchForm.status" placeholder="请选择订单状态" filterable
              default-first-option>
              <el-option  label="已支付" value="1"></el-option>
              <el-option  label="已退款" value="2"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="日期">
            <el-date-picker v-model="searchForm.date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary"
            @click="$refresh([getOrdersList, getStatusNumber], true)">查询</el-button>
          <el-button icon="el-icon-refresh"
            @click="$reset(getOrdersList, { patientName: null, patientPhone: null, doctorName: null, createTime: null, status: searchForm.status,deptId:searchForm.deptId })">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- 状态菜单 -->
      <el-tabs v-model="activeIndex" mode="horizontal" @tab-click="handleSelect">
        <el-tab-pane v-for="item in menuList" :key="item.value" :label="item.label" :name="item.value" />
      </el-tabs>
      <!-- 订单划价列表 -->
      <el-table v-loading="loading" :data="orderList" :max-height="tableHeight" border>
        <el-table-column fixed="left" type="index" label="序号" width="50" />
        <el-table-column fixed="left" prop="patientName" label="患者姓名" min-width="80" />
        <el-table-column prop="phone" label="手机号码" min-width="120" />
        <el-table-column prop="doctorName" label="看诊医生" min-width="100" />
        <el-table-column prop="orderNumber" label="订单编号" min-width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="showEdit(scope.row)">{{ scope.row.orderNumber }}</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="type" label="处方来源" min-width="80">
          <template slot-scope="scope">
            <b>{{scope.row.type}}</b>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="recipeType" label="处方类型" min-width="80">
          <template slot-scope="scope">
            <b>{{scope.row.recipeType}}</b>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="channel" label="支付途径" min-width="80">
          <template slot-scope="scope">
            <b>{{scope.row.channel}}</b>
          </template>
        </el-table-column> -->
        <el-table-column  label="订单状态" min-width="100">
          <template slot-scope="scope">
            <b>{{ scope.row.orderStatus==2?'已退款':"已支付"}}</b>
          </template>
        </el-table-column>
        <el-table-column prop="totalPrice" label="订单金额(元)" min-width="110"></el-table-column>
        <el-table-column prop="realPay" label="订单实付(元)" min-width="110"></el-table-column>
        <!-- <el-table-column prop="statusStr" label="物流跟踪" min-width="80"
          v-if="type == '中药处方划价单' || type == '隐秘处方划价单'">
          <template slot-scope="scope">
            <el-button size="medium" v-show="scope.row.trickShow" icon="el-icon-coordinate"
            @click="getLogisticsData(scope.row.orderDelivery, type)" type="text" class="btn-address"/>
          </template>
        </el-table-column> -->
        <el-table-column prop="date" label="更新时间" min-width="160"/>
      </el-table>
      <!-- 物流跟踪 -->
      <Logistics :Logistics="Logistics" :dialogLogistics="dialogLogistics" @dialogLogisticsBack="dialogLogisticsBack"
        :companyName="companyName" />
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getOrdersList)" :total="total"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
    </div>
  </Card>
</template>

<script lang="js">
import Logistics from "@/components/Delivery/Logistics.vue"; // 物流跟踪组件
import { getLogisticsData } from "@/utils/printInfo"; // 引入获取打印数据方法
import { drugPaymentList, statusNumDrug } from "@/api/drugpayment"; // 中药处方划价单请求
import { comboPaymentList, statusNumCombo } from "@/api/combopayment"; // 隐秘处方划价单请求
import { physioPaymentList, statusNumPhysio } from "@/api/physiopayment"; // 理疗处方划价单请求
import { physioCase, drugCase, comboCase } from "@/utils/switchCase"; // 订单状态处理
import { dictText }from '@/utils/validateBase'
import { statusList } from '@/utils/const'
import { isNull } from "../utils/validateBase";
export default {
  name: "OrderList",
  components: { Logistics },
  data() {
    return {
      loading: true, // 加载中
      type: '中药处方划价单',
      searchForm: {
        patientName: null, phone: null, doctorName: null, status:null,
        createTime: null, deptId: this.$session.get('deptId'), date:null
      }, // 查询表单
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      pay: false, // 收费状态
      orderList: [], // 挂号列表
      doctorId: null, // 医生id
      doctorOptions: [], // 医生选项
      dialogRefund: false, // 退款模态框
      refundForm: {}, // 退款对象
      refundFormRules: {
        refundWay: [{ required: true, message: '请选择退款方式！', trigger: 'change' }],
        refundRemark: [{ required: true, message: '请输入退款备注！', trigger: 'blur' }]
      }, // 验证规则
      drugStatusOptions: [
        { value: 'null', label: "全部订单", name: 'all', number: 0 },
        // { value: "2", label: "订单已生成", name: 'generateSuccess', number: 0 },
        // { value: "3", label: "正在审方", name: 'audit', number: 0 },
        // { value: "4", label: "正在配方", name: 'recipe', number: 0 },
        // { value: "5", label: "正在复审", name: 'recheck', number: 0 },
        // { value: "6", label: "正在加工", name: 'processing', number: 0 },
        // { value: "7", label: "正在打包", name: 'packaging', number: 0 },
        // { value: "8", label: "正在配送", name: 'delivery', number: 0 },
        // { value: "9", label: "配送到达", name: 'goodsArrive', number: 0 },
        // { value: "10", label: "订单完成", name: 'complete', number: 0 },
        // { value: "-4", label: "已跑单", name: 'single', number: 0 },
        // { value: "-3", label: "快递退回", name: 'deliveryBack', number: 0 },
        // { value: "-2", label: "已退款", name: 'refund', number: 0 },
        // { value: "-1", label: "已作废", name: 'cancel', number: 0 }
      ], // 中药处方划价单状态
      dialogLogistics: false, // 物流跟踪模态框状态
      Logistics: [], // 物流跟踪数组
      activeIndex: 'null', // 状态菜单默认激活
      menuList: [], // 状态菜单
      pickerOptions: { // 日期不可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      companyName: null, // 当前选择行的配送公司
      deptId: this.$session.get('deptId'), // 当前医馆id
      tableHeight: 0, // 表格最大高度
    };
  },
  props: {
    physioFlag: Boolean
  },
  //监听属性 类似于data概念
  computed: {
    formatNumber() {
      let self = this;
      return function (val) {
        // 对计算属性进行传参
        if (val) {
          return self.$toFixed(val);
        }
      };
    },
    formatStatus() {
      let self = this;
      return function (val) {
        // 对计算属性进行传参
        if (val) {
          
        }
      };
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 380;
    if (this.$route.query.type) this.type = this.$route.query.type;
    this.getOrdersList(); // 获取已划价列表
    this.getStatusNumber(); // 获取状态菜单数量
    this.$getDoctorOptions(); // 获取所有医生列表
  },
  methods: {
    // 获取划价单列表
    async getOrdersList() {
      if (this.type == '中药处方划价单') {
        this.menuList = this.drugStatusOptions;
        this.searchForm.orderStatusList=[]
        if(!isNull(this.searchForm.status)) this.searchForm.orderStatusList[0]= this.searchForm.status
        this.searchForm.orderStatusList[0]
        let { total, rows, code } = await drugPaymentList({ currentPage: this.currentPage, pageSize: this.pageSize, ...this.searchForm });
        if (code == 200) {
          if (total > 0) {
            rows.forEach(item => {
              this.switchCase(item);
              drugCase(item);
              // item.realPay == null ? item.realPay = '0' : item.realPay = item.realPay;
              item.totalPrice = item.totalPrice;
              item.paymentId = item.orderPaymentRecipeDrugId;
              if (item.orderDelivery && item.orderDelivery.companyName == '同城快递') {
                if (item.orderDelivery && item.status > 0) item.trickShow = true;
                else item.trickShow = false;
              } else if (item.orderDelivery && item.orderDelivery.companyName == '顺丰快递') {
                if (item.orderDelivery && item.status > 0 && item.isDeliveryPrint == 1) item.trickShow = true;
                else item.trickShow = false;
              } else item.trickShow = false;
            });
          }
          this.orderList = rows;
          this.total = total;
        }
        this.loading = false;
      } else if (this.type == '隐秘处方划价单') {
        this.menuList = this.comboStatusOptions;
        let { total, rows, code } = await comboPaymentList({ exceptStatus: '0', pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm });
        if (code == 200) {
          if (total > 0) {
            rows.forEach(item => {
              this.switchCase(item);
              comboCase(item);
              item.realPay == null ? item.realPay = '0' : item.realPay = item.realPay;
              item.totalPrice = item.totalPrice;
              item.orderNumber = item.comboOrderNumber;
              item.paymentId = item.paymentRecipeComboId;
              if (item.orderDelivery && item.orderDelivery.companyName == '同城快递') {
                if (item.orderDelivery && item.status > 0) item.trickShow = true;
                else item.trickShow = false;
              } else if (item.orderDelivery && item.orderDelivery.companyName == '顺丰快递') {
                if (item.orderDelivery && item.status > 0 && item.isDeliveryPrint == 1) item.trickShow = true;
                else item.trickShow = false;
              } else item.trickShow = false;
            });
          }
          this.orderList = rows;
          this.total = total;
        }
        this.loading = false;
      } else {
        this.menuList = this.physioStatusOptions;
        let { total, rows, code } = await physioPaymentList({ exceptStatus: '0', pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm });
        if (code == 200) {
          if (total > 0) {
            rows.forEach(item => {
              this.switchCase(item);
              physioCase(item);
              item.realPay == null ? item.realPay = '0' : item.realPay = item.realPay;
              item.totalPrice = item.totalPrice;
              item.orderNumber = item.physioOrderNumber;
              item.paymentId = item.orderPaymentRecipePhysioId;
            });
          }
          this.orderList = rows;
          this.total = total;
        }
        this.loading = false;
      }
    },
    // 获取每一个状态数量
    getStatusNumber() {
      if (this.type == '中药处方划价单') this.getNumber(statusNumDrug, this.drugStatusOptions);
      else if (this.type == '隐秘处方划价单') this.getNumber(statusNumCombo, this.comboStatusOptions);
      else this.getNumber(statusNumPhysio, this.physioStatusOptions);
    },
    async getNumber(request, menuArr) {
      let search = this.searchForm;
      let { code, data } = await request({
        patientName: search.patientName, patientPhone: search.patientPhone,
        doctorName: search.doctorName, createTime: search.createTime
      });
      if (code == 200) {
        menuArr.forEach(item => {
          for (let key in data) {
            if (item.name == key) item.number = data[key];
          }
        });
      }
    },
    // 处理参数
    switchCase(item) {
      item.recipeType == '0' ? item.recipeType = '电子处方' : item.recipeType = '手写处方';
      switch (item.type) {
        case '0': item.type = '馆内'; break;
        case '1': item.type = '拍单'; break;
        case '2': item.type = '馆外'; break;
        case '3': item.type = '网诊'; break;
      }
      if (item.payee == '商户号') item.channel = '微信';
      else item.channel = '线下';
    },
    // 查看详情页面
    showEdit(obj) {
      this.$router.push(`./orderdetails?orderId=${obj.orderId}`);
    },
    getLogisticsData: getLogisticsData, // 获取物流跟踪信息
    // 获取物流跟踪组件传参
    dialogLogisticsBack(val) { this.dialogLogistics = val },
    // 切换激活菜单
    handleSelect() {
      if (this.activeIndex != 'null') this.searchForm.status = this.activeIndex;
      else this.searchForm.status = undefined;
      this.$refresh(this.getOrdersList);
    },
    // 切换划价单类型
    setType(val) {
      this.loading = true;
      this.searchForm.status = undefined;
      this.activeIndex = 'null';
      setTimeout(() => {
        this.getStatusNumber();
        this.$refresh(this.getOrdersList);
      }, 100);
      this.type = val;
    },
  },
};
</script>

<style lang="less" scoped>
.btn-address {
  margin: 0 auto;
  display: block;
}</style>